module.exports = __webpack_public_path__ + "img/home.3fdc8ba3.gif";